import { render } from "./OnDemandEyeColor.vue?vue&type=template&id=7c74d8f4"
import script from "./OnDemandEyeColor.vue?vue&type=script&lang=js"
export * from "./OnDemandEyeColor.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__